import { render } from "./CategoryCreate.vue?vue&type=template&id=4ed99fe0&ts=true"
import script from "./CategoryCreate.vue?vue&type=script&lang=ts"
export * from "./CategoryCreate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__